import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-internal-links-list',
  templateUrl: './internal-links-list.component.html',
  styleUrls: ['./internal-links-list.component.css'],
})
export class InternalLinksListComponent implements OnInit {
  url: string = 'internalLink';
  data: Array<any> = [];
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];

  // Filters
  searchText = '';
  filterStatus = '';
  filterMinScore = false;
  filterSourceUrl = '';

  currentPage: number = 1;
  itemsPerPage: number = 50;
  totalItems: number = 0;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    // Note: getDataTwo uses 'type' as a general filter parameter.
    // We'll calculate filters locally for now as the current backend listData
    // implementation in internalLinks.js only handles 'search' (text) and pagination.
    this.dataService
      .getDataTwo(
        this.url,
        this.searchText,
        '',
        this.currentPage,
        this.itemsPerPage,
      )
      .subscribe((response) => {
        if (response && response.data) {
          this.data = response.data;
          this.totalItems = response.count;
          this.filteredData = [...this.data];
          this.updateSuggestions();
        }
      });
  }

  updateSuggestions() {
    const set = new Set<string>();
    this.data.forEach((x) => x.urlPath && set.add(x.urlPath));
    this.searchSuggestions = Array.from(set);
  }

  filter() {
    const t = this.searchText.trim().toLowerCase();
    if (!t) {
      this.filteredData = [...this.data];
      return;
    }

    this.filteredData = this.data.filter((x) => {
      const hay = [x.sourceUrl, x.targetUrl, x.anchorText]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return hay.includes(t);
    });
  }
}
